import { useEffect, useState } from 'react';
import vendorService from '../../../services/VendorService';

export default function useFetchVendorRecords() {
  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorError, setVendorError] = useState('');
  const [vendorRecords, setVendorRecords] = useState([]);

  //for user table inline editing options
  const [vendorList, setVendorList] = useState([]);

  useEffect(() => {
    const fetchVendorRecords = async () => {
      try {
        setVendorLoading(true);
        const vendorList = await vendorService.getVendorsFromQBO();
        const vendorRecords = vendorList.data.data.QueryResponse.Vendor;

        const vendorListOption = vendorList.data.data.QueryResponse.Vendor.map((c) => {
          return {
            value: c.DisplayName,
            label: c.DisplayName,
            id: c.Id,
            TermRef: c.defaultDueDateTerm || c.TermDetails || c.TermRef || null
          };
        });

        setVendorList(vendorListOption);

        setVendorRecords(vendorRecords);
      } catch (error) {
        setVendorError(error?.message || 'Could not fetch vendor from quicbooks');
      } finally {
        setVendorLoading(false);
      }
    };
    fetchVendorRecords();
  }, []);
  return { vendorRecords, vendorError, vendorLoading, vendorList };
}
